import { createContext } from "react";
export var DeviceQueryContext = createContext(null);